import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import 'react';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { color } from '@lendi-ui/color';
import LendiContainer from '@lendi-ui/container';
import { grid, unit } from '@lendi-ui/grid';
import { py, my, pb, mb, mx, mr } from '@lendi-ui/spacing';
import { Heading as Heading$1, Link as Link$1, Body as Body$1 } from '@lendi-ui/typography';
import styled from 'styled-components';
import { format } from 'date-fns';
import { gte } from '@lendi-ui/breakpoint';
import { jsxs, jsx } from 'react/jsx-runtime';

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7$1;
var Wrapper$1 = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  width: 100%;\n  background-color: ", ";\n"])), function (_ref) {
  var variant = _ref.variant;
  return variant === 'white' ? 'white' : '#f1f1f1';
});
var Container$1 = styled(LendiContainer)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  ", "\n"])), py('xxxl'));
var Reviews = styled.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  row-gap: 24px;\n"])), grid({
  gutter: 'sm'
}), my('md'));
var Title = styled(Heading$1)(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  text-align: center;\n  font-weight: 700;\n  ", "\n"])), pb('xxs'));
var SubTitle = styled(Heading$1)(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: 'Open Sans';\n  font-weight: 300;\n  text-align: center;\n"])), color('shade.700'));
var Logo = styled.img.attrs({
  height: 40
})(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n  display: block;\n  ", "\n  ", "\n"])), mb('md'), mx('auto'));
var Link = styled(Link$1)(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n  text-decoration: none;\n  display: block;\n  color: #006c8a;\n  text-align: center;\n"])));

var Star = function Star(props) {
  return /*#__PURE__*/jsxs("svg", _objectSpread(_objectSpread({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 33",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("title", {
      children: "Path"
    }), /*#__PURE__*/jsx("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/jsx("g", {
        transform: "translate(-302.000000, -277.000000)",
        fill: "#FFBF00",
        fillRule: "nonzero",
        children: /*#__PURE__*/jsx("g", {
          transform: "translate(150.000000, 236.000000)",
          children: /*#__PURE__*/jsx("g", {
            transform: "translate(0.000000, 1.000000)",
            children: /*#__PURE__*/jsx("g", {
              transform: "translate(32.000000, 40.512821)",
              children: /*#__PURE__*/jsx("g", {
                transform: "translate(120.000000, 0.000000)",
                children: /*#__PURE__*/jsx("polygon", {
                  points: "32 12.1538462 22 19.5811966 26 32.4102564 16 24.3076923 6 32.4102564 10 19.5811966 0 12.1538462 12 12.1538462 16 0 20 12.1538462"
                })
              })
            })
          })
        })
      })
    })]
  }));
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
var StyledStar = styled(Star)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), mr('xxs'));
var Footer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  align-self: flex-end;\n"])));
var Heading = styled(Heading$1)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  font-weight: 700;\n  ", "\n  ", "\n"])), my('xs'), gte('lg')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    align-items: center;\n    ", "\n    height: 48px;\n  "])), my('md')));
var Body = styled(Body$1)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n  max-height: 80px;\n  overflow: hidden;\n"])), mb('md'));
var Container = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  padding: 40px 32px;\n  height: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n  border-bottom-right-radius: 90px;\n  background-color: ", ";\n\n  > div {\n    flex-basis: 100%;\n  }\n"])), function (_ref) {
  var parentBackground = _ref.parentBackground;
  return parentBackground === 'white' ? '#f1f1f1' : 'white';
});
var Wrapper = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", "\n"])), unit({
  size: {
    lg: 1 / 3,
    md: 1
  }
}));

var MAX_TITLE_LENGTH = 75;
var MAX_DESCRIPTION_LENGTH = 132;
var NUM_STARS = 5;
var Review = function Review(_ref) {
  var author = _ref.author,
    date = _ref.date,
    location = _ref.location,
    title = _ref.title,
    description = _ref.description,
    parentBackground = _ref.parentBackground;
  var formattedDate = format(new Date(date), 'MMMM Y');
  var parsedTitle = title.length > MAX_TITLE_LENGTH ? "".concat(title.slice(0, MAX_TITLE_LENGTH - 3).trim(), "...") : title;
  var parsedDescription = description.length > MAX_DESCRIPTION_LENGTH ? "".concat(description.slice(0, MAX_DESCRIPTION_LENGTH - 3), "...") : description;
  return /*#__PURE__*/jsx(Wrapper, {
    children: /*#__PURE__*/jsxs(Container, {
      parentBackground: parentBackground,
      children: [/*#__PURE__*/jsx("div", {
        children: new Array(NUM_STARS).fill(null).map(function (_, index) {
          return /*#__PURE__*/jsx(StyledStar, {}, index);
        })
      }), /*#__PURE__*/jsx(Heading, {
        size: "xs",
        children: parsedTitle
      }), /*#__PURE__*/jsx(Body, {
        size: "sm",
        children: parsedDescription
      }), /*#__PURE__*/jsxs(Footer, {
        children: [/*#__PURE__*/jsxs(Body$1, {
          size: "sm",
          children: [author && /*#__PURE__*/jsxs("strong", {
            children: [author, ","]
          }), " ", location]
        }), /*#__PURE__*/jsx(Body$1, {
          size: "sm",
          children: formattedDate
        })]
      })]
    })
  });
};

var Testimonial = function Testimonial(_ref) {
  var heading = _ref.heading,
    subTitle = _ref.subTitle,
    items = _ref.items,
    logo = _ref.logo,
    buttonLink = _ref.buttonLink,
    variant = _ref.variant;
  return /*#__PURE__*/jsx(Wrapper$1, {
    variant: variant,
    children: /*#__PURE__*/jsxs(Container$1, {
      children: [logo.fluid && /*#__PURE__*/jsx(Logo, {
        src: logo.fluid.src,
        alt: logo.alt
      }), /*#__PURE__*/jsx(Title, {
        size: "lg",
        children: heading
      }), /*#__PURE__*/jsx(SubTitle, {
        size: "xxs",
        children: subTitle
      }), /*#__PURE__*/jsx(Reviews, {
        children: items.map(function (review, index) {
          return /*#__PURE__*/jsx(Review, _objectSpread({
            parentBackground: variant
          }, review), index);
        })
      }), buttonLink && /*#__PURE__*/jsx(Link, {
        href: buttonLink,
        size: "xs",
        children: "All reviews"
      })]
    })
  });
};

export { Testimonial as default };
